import { addMessage, setMessagesTabOpen } from '../actions/Chat'
import store from '../index'

const { dispatch } = store

export const dispatchAddMessage = message => dispatch(addMessage(message))

export const dispatchSetMessagesTabOpen = isOpen =>
    dispatch(setMessagesTabOpen(isOpen))
